const Steering = () =>
  import(
    /* webpackChunkName: "Steering" */ "@/components/rapsotec/Steering.vue"
  );
const Projects = () =>
  import(
    /* webpackChunkName: "Projects" */ "@/components/rapsotec/Projects.vue"
  );
const Referencials = () =>
  import(
    /* webpackChunkName: "Referencials" */ "@/components/rapsotec/Referencials.vue"
  );
const TechnicalDocumentation = () =>
  import(
    /* webpackChunkName: "TechnicalDocumentation" */ "@/components/rapsotec/TechnicalDocumentation.vue"
  );
const Questionnaire = () =>
  import(
    /* webpackChunkName: "Questionnaire" */ "@/components/rapsotec/Questionnaire.vue"
  );

const UserProfile = () =>
  import(
    /* webpackChunkName: "UserProfile" */ "@/components/rapsotec/UserProfile.vue"
  );

import ProjectsChildrens from "./rapsotec/ProjectsChildrens";
import ReferencialChildrens from "./rapsotec/ReferencialChildrens";
import SteeringChildren from "./rapsotec/SteeringChildren";
import TechnicalDocumentationChildren from "./rapsotec/TechnicalDocumentationChildren";
import QuestionnaireChildrens from "./rapsotec/QuestionnaireChildrens";
import isInGroupsMiddlewarePermission from "@/utils/isInGroupsMiddlewarePermission";
import { SOCOTEC_GROUPS } from "@/utils/users";

export const TECHNICAL_DOCUMENTATION_ROUTE_NAME = "technical-documentation";
export default [
  {
    path: ":entity(SPS|DIAG|APB|CT)?",
    component: Steering,
    children: SteeringChildren,
  },
  {
    path: "projects",
    component: Projects,
    children: ProjectsChildrens,
  },
  {
    path: "edit-profile",
    name: "edit-profile",
    component: UserProfile,
    meta: {
      allowExternal: true,
    },
  },
  {
    path: "referencials",
    component: Referencials,
    children: ReferencialChildrens,
    beforeEnter: isInGroupsMiddlewarePermission([
      SOCOTEC_GROUPS.TECHNICAL_DIRECTION,
    ]),
  },
  {
    path: "technical-documentation",
    name: TECHNICAL_DOCUMENTATION_ROUTE_NAME,
    component: TechnicalDocumentation,
    children: TechnicalDocumentationChildren,
    beforeEnter: isInGroupsMiddlewarePermission([
      SOCOTEC_GROUPS.TECHNICAL_DIRECTION,
    ]),
  },
  {
    path: "questionnaires",
    component: Questionnaire,
    children: QuestionnaireChildrens,
  },
];
